import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { notificationsReducer } from './notifications.reducer';
import { sessionReducer } from './session.reducer';
import { usersReducer } from './users.reducer';
import { wizardReducer } from './wizard.reducer';
import { organizationsReducer } from './organizations.reducer';
import { toastReducer } from './toast.reducer';
import { filterReducer } from './filter.reducer';
import { lotsReducer } from './lots.reducer';
import { dialogReducer } from './dialog.reducer';
import { treeReducer } from './tree.reducer';
import { errorDialogReducer } from './errorDialog.reducer';

const rootReducer = combineReducers({
  wizard: wizardReducer,
  notifications: notificationsReducer,
  routing: routerReducer,
  session: sessionReducer,
  users: usersReducer,
  organizations: organizationsReducer,
  toast: toastReducer,
  filter: filterReducer,
  lots: lotsReducer,
  dialog: dialogReducer,
  tree: treeReducer,
  errorDialog: errorDialogReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/root.reducer.js